export default __webpack_public_path__ + "static/media/gold-tea-box.9e61fa0f.png";